<header class="page-title-box position-relative px-3 py-2 bg-white d-flex shadow-sm">
  <div class="w-50 d-flex justify-content-start align-items-center">
    <p class="m-0 fw-medium">{{title}}</p>
  </div>
  <div class="w-50 d-flex justify-content-end align-items-center gap-3">
    <breadcrumb [links]="links" />

    <ng-content select="[buttons]"></ng-content>
  </div>
</header>